<mat-expansion-panel class="panel">
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{ 'SALES_ORDERS.TITLE' | translate }}
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="orders">
    <span>
      <span [innerHTML]="'SALES_ORDERS.RESELLER_TIP' | translate: { reseller_page_url: resellerURL$ | async }"></span>
      <mat-icon inline>open_in_new</mat-icon>
    </span>

    @if (orders$ | async; as orders) {
      @for (order of orders; track order.orderId) {
        <mat-card appearance="outlined" class="association-card-contents">
          <mat-card-title>
            {{ order.orderId }}
          </mat-card-title>
          <mat-card-subtitle>
            @if (!!order.requestedActivation) {
              <span>
                {{ 'SALES_ORDERS.CONTRACT_START' | translate }}: {{ order.requestedActivation | date }}
                <br />
              </span>
            }
            <div class="status-badge">
              <glxy-badge [color]="order.badge.color">
                {{ order.badge.text | translate }}
              </glxy-badge>
            </div>
          </mat-card-subtitle>
        </mat-card>
      }
    } @else {
      <glxy-loading-spinner id="spinner-container" [fullWidth]="true" [fullHeight]="true"></glxy-loading-spinner>
    }
  </div>
</mat-expansion-panel>
